import { repeat } from 'ramda';

import { nestItems } from 'utils';

const updateNestedName = (el, nestedLevel = 0) => {
  let result: Record<'name' | 'value', string>[] = [];
  if (!el) return result;

  result.push({
    name: nestedLevel
      ? `${repeat('—', nestedLevel).join('')}  ${el.name}`
      : el.name,
    value: el.clientGroupID,
  });

  if (el.children.length) {
    result = result.concat(
      ...el.children.map(ch => updateNestedName(ch, nestedLevel + 1)),
    );
  }
  return result;
};

export const getGroupOptionsWithNameHierarchy = (els = []) => {
  if (!els.length) return [];

  return nestItems(els, {
    idIndicator: 'customerGroupID',
    parentIndicator: 'parentID',
  })
    .map(el => updateNestedName(el))
    .flat();
};
